import { useState } from 'react';
import { CustomerList } from './list';
import { CustomerFormModal } from './CustomerFormModal';
import { Customer } from '../../types/customer';

export const CustomersPage = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState<Customer | null>(null);

  const handleCreateClick = () => {
    setSelectedCustomer(null);
    setModalOpen(true);
  };

  const handleCustomerClick = (customer: Customer) => {
    setSelectedCustomer(customer);
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setSelectedCustomer(null);
  };

  return (
    <>
      <CustomerList
        onCreateClick={handleCreateClick}
        onCustomerClick={handleCustomerClick}
      />
      <CustomerFormModal
        open={modalOpen}
        onClose={handleModalClose}
        customer={selectedCustomer}
      />
    </>
  );
};

export { CustomerList } from './list';
